import { Injectable } from '@angular/core';

import { mergeMap, take } from 'rxjs/operators';
import { from, Observable } from 'rxjs';

import { ServerDataBackupService } from '../services/http-services/server-data-backup.service';
import { ServerDataComponent } from '../../admin-module/server-data/server-data.component';
import { ServerDataBackupDialogMessagesEnum } from '../enums/toastr-messages/server-data-backup-dialog-messages.enum';
import { ServerDataBackupingInProgress } from '../models/view-models/backups-models/server-data-backuping-in-progress.view-model';

@Injectable()
export class AdminTabsGuard  {

    constructor(private serverDataBackupService: ServerDataBackupService) { }

    canDeactivate(component: ServerDataComponent): Observable<boolean> {
        return from(this.serverDataBackupService.isPendingFileDownload$.pipe(
            take(1),
            mergeMap(async (info: ServerDataBackupingInProgress) => {
                if (info.IsProgressInActiveStatus && component.deleteDialogService) {
                    const isSubmitRelink: boolean = await component.deleteDialogService
                        .show((info.IsImportModeSelected
                            ? ServerDataBackupDialogMessagesEnum.OnAdminTabChangedWhileUnpacking
                            : ServerDataBackupDialogMessagesEnum.OnAdminTabChangedWhileDownloading), false).toPromise();
                    return isSubmitRelink;
                } else {
                    return true;
                }
            })));
    }
}
